import { render, staticRenderFns } from "./bf-modal.vue?vue&type=template&id=3a13c25e&scoped=true&lang=pug&"
import script from "./bf-modal.vue?vue&type=script&lang=js&"
export * from "./bf-modal.vue?vue&type=script&lang=js&"
import style0 from "./bf-modal.vue?vue&type=style&index=0&id=3a13c25e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a13c25e",
  null
  
)

export default component.exports